import { MuiButton } from './MuiButton';
import { MuiDataGrid } from './MuiDataGrid';

export const components = {
  MuiButton,
  MuiDataGrid,
};
